import { get } from 'lodash';

import { maxFileSize } from 'shared/constants';

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce((error, validator) => {
      if (error) {
        return error;
      } else if (typeof validator !== 'function') {
        throw new Error('Validator is not a function');
      }
      return validator(value);
    }, undefined);

export const fileTooLarge = (modalAlert, file) => {
  if (file.size > maxFileSize) {
    modalAlert.open(
      `${file.name} - ${translate('File size is too large')} (10 Mb max)`,
      'The following files can not be uploaded:',
    );
    return true;
  }
};

export const validateRequiredFn = (value: any) => (value ? undefined : translate('Field is required'));

export const validateMaxLength = (value: string, length: number) =>
  value?.length > length ? translate('Maximum {{ length }} characters', { length }) : undefined;

export const validateMinLength = (value: string, length: number) =>
  value?.length < length ? translate('Minimum {{ length }} characters', { length }) : undefined;

export const validateRequired = [(value) => (value ? undefined : translate('Field is required'))];

export const validateRequiredDraftJS = [
  (value: string) => {
    const div = document.createElement('div');
    div.innerHTML = value;
    return div.innerText ? undefined : translate('Field is required');
  },
];

export const translatedFileIsTooLarge = (file) =>
  translate('File {{ filename }} is too large (10 Mb max)', {
    filename: file.name,
  });

export const requiredIfChanged = (path) => (value, values, reduxForm) => {
  const initialValue = get(reduxForm.initialValues.toJS(), path);
  if (value !== initialValue) {
    return value ? undefined : translate('Field is required');
  }
};

export const requiredIfTouched = (path) => (value, values, reduxForm) => {
  // @ts-expect-error
  const { touched } = get(window.store.getState().toJS().form[reduxForm.form].fields, path, {});
  if (touched) {
    return value ? undefined : translate('Field is required');
  }
};

export const validateUrl = (url: string) => {
  const urlRegex = /https?:\/\/(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[a-zA-Z0-9#?&%=.-]*)?/;
  return urlRegex.test(url);
};
